export const PROJECT_CHECKLIST = true